import { GET_INTERNATIONAL_CITY_REQUEST, GET_INTERNATIONAL_CITY_SUCCESS, GET_INTERNATIONAL_CITY_ERROR } from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getInternationalCity = (token) => dispatch => {
    dispatch({ type: GET_INTERNATIONAL_CITY_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InternationalCity`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_INTERNATIONAL_CITY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_INTERNATIONAL_CITY_ERROR,
                payload: error.response,
            });
        })
}

